import { Button } from '@mui/material';
import { palette } from '../theme/palette';
import { styled } from '@mui/material/styles';

const BaseButton = styled(Button)(() => ({
  fontSize: '14px',
  letterSpacing: '.5px',
  height: '40px',
  color: 'white',
  borderRadius: '1px',
  boxShadow: 'none',
  ':hover': {
    boxShadow: 'none',
  },
}));

export const PrimaryButton = styled(BaseButton)`
  background: ${palette.primary.main};
  border-radius: 5px;
  height: 34px;
  padding: 0 20px;
  font-size: 13.5px;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  :hover {
    background: ${palette.primary.main};
    color: 'white';
  }
`;

export const PrimaryLightButton = styled(BaseButton)`
  border-radius: 5px;
  border: 1px solid ${palette.primary.main};
  color: ${palette.custom.darkGrey};
  height: 34px;
  font-size: 13.5px;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  :hover {
    background: ${palette.primary.contrastText};
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background: ${palette.custom.darkGrey};
  border-radius: 5px;
  height: 34px;
  padding: 0 20px;
  font-size: 13.5px;
  letter-spacing: 0.675px;
  text-transform: uppercase;
  color: ${palette.custom.white};
  :hover {
    background: ${palette.custom.darkGrey};
    color: ${palette.custom.white};
  }
`;

export const LinkButton = styled(Button)`
  padding: 0;
  background: none;
  :hover {
    background: none;
  }
`;
